/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";
import MDTypography from "components/MDTypography";

const VersionChecker = () => {
  const [version, setVersion] = useState("");
  const [open, setOpen] = useState(false);
  const [countdown, setCountdown] = useState(60);
  let currentVersion = "";

  useEffect(() => {
    const checkVersion = () => {
      fetch(`/version.json?v=${new Date().getTime()}`)
        .then((res) => res.json())
        .then((data) => {
          if (!currentVersion) {
            currentVersion = data.version;
          } else if (currentVersion !== data.version) {
            setVersion(data.version);
            setOpen(true);
          }
        })
        .catch((err) => console.error("Error al obtener version.json", err));
    };

    checkVersion();
    const interval = setInterval(checkVersion, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    let timer;
    if (open && countdown > 0) {
      timer = setTimeout(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    } else if (countdown === 0) {
      window.location.reload(true);
    }
    return () => clearTimeout(timer);
  }, [open, countdown]);

  const handleReload = () => {
    window.location.reload(true);
  };

  return (
    <Dialog open={open} onClose={() => {}} disableEscapeKeyDown>
      <DialogTitle style={{ backgroundColor: "#1a2035", color:"white" }}>Nueva versión disponible</DialogTitle>
      <DialogContent style={{ backgroundColor: "#1a2035", color:"white" }}>
        <MDTypography gutterBottom>
          Se detectó una nueva versión de la aplicación (v{version}).
        </MDTypography>
        <MDTypography color="error">
          La página se recargará automáticamente en {countdown} segundos.
        </MDTypography>
      </DialogContent>
      <DialogActions style={{ backgroundColor: "#1a2035" }}>
        <Button onClick={handleReload} variant="contained" color="primary">
          Recargar ahora
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VersionChecker;
